
import { Card } from "@/components/ui/card";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { AdminDashboard } from "@/components/admin/AdminDashboard";
import { useState } from "react";

const ADMIN_PASSWORD = "vaseline2024";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

const AdminContent = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Not authenticated - show login
  if (!isAuthenticated) {
    return <AdminLogin onLogin={setIsAuthenticated} adminPassword={ADMIN_PASSWORD} />;
  }

  // Authenticated - show dashboard
  return <AdminDashboard />;
};

const Admin = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AdminContent />
    </QueryClientProvider>
  );
};

export default Admin;
